import React from 'react';
import Wave from './Wave';
import './Section.css';

// INSTALL NPM: styled-components
const Section = (props) => (
    <div className="SectionGroup">
            <div className="WaveTop"><Wave /></div>
            <div className="WaveBottom"><Wave/></div>
            <div className="SectionLogos" >
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/JrunZ1PX/39c46a0d-a510-48c0-8063-dda618ce15c3.png?v=89a17fb5b559f65d8014a252c437d741" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/p9uNor9O/4a376981-bdbc-451a-b4c9-59d4ea0e7ecc.png?v=f712dd81f04d8f7b1b176a5615d3000f" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/NQu79wEg/13e84d5e-12fb-4337-8031-ec04118d070e.png?v=3b87ba3fa9324ad61cd0fc5c50d14689" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/04u5nxGl/35f23605-7534-4fc4-86d5-49c8a924dece.png?v=61211e3a3d305393ff53bd1c536bb886" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/7KuANb9d/1f9329ea-2bae-432d-b07d-8b7d5f0acffe.png?v=dd525abc5ac8dc482cb6c43bc366d97b" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/qGuRnlLK/5681f098-725e-4605-a940-da2cc1e23659.png?v=4ee8e772a826562b3da179d9edaf316d" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/d5u6jP5j/291d553e-5e14-4ea0-b5b9-bf88140b0574.png?v=a8abb0b21cd1a5af83d5a11853c2e302" width="50" />
                <img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/d5u6jwKZ/3716b692-8f2b-4868-abc6-224a2855bf98.png?v=b5fdc3c55c72ccf89190a526fe8b5dfe" width="50" />
            </div>
        
            <div className="SectionTitleGroup">
                <div className="SectionTitle">{props.title}</div>
                <div className="SectionText">{props.text}</div>
            </div>
    </div>
)

export default Section


// WEBPACK FOOTER //
// ./src/components/Section.js